/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import TagsList3 from "components/TagList3";
import DialogComponent, { ContentTextArea, DialogConfirm, DialogRejected, TextArea2 } from 'components/Dialog';
import { LostCancelButton } from 'components/index';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { ButtonContent, BorderSwitch } from "./styles";
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import { Col, Row } from 'components/Grid';
import DragZoneUpload from 'components/DragZoneUpload'
import Switch from 'react-switch';
import { useBindMessage, useWordingHtmlModal, useHeaderNbi, useGetDocuments, useIsApprovedBind, useGetAuthorizationPolicyDocuments, useGetSchedulleAssumptions } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';
import { useGetQuestionnaireAnswer } from '@fitinsur/services/QuestionnaireAnswerService';
import { EndorsementTagList, FileModal } from '@fitinsur/components'

export default function OrderToBind(props) {
  const [isEndorsement, setIsEndorsement] = useState(false);
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [userComments, setUserComments] = useState(null);
  const [wordingFile, setWordingFile] = useState({});
  const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
  const [isApproved, setIsApproved] = useState(null);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [isBound, setIsBound] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [isLocked, setIsLocked] = useState(false);
  const [disableExecute, setDisableExecute] = useState(false);
  const [endorsementDocuments, setEndorsementDocuments] = useState([]);
  const [includeSchedulleQst, setIncludeSchedulleQst] = useState(null);
  const [operation, setOperation] = useState(null);

  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const isClient = authContext.enumProfile === 1 ? true : false;

  const {
    data: useBindMessageData,
    loading: useBindMessageLoading,
    error: useBindMessageError,
    status: useBindMessageStatus,
    request: useBindMessageRequest,
  } = useBindMessage(props.match.params.idOperation);

  const {
    data: useWordingHtmlModalData,
    loading: useWordingHtmlModalLoading,
    error: useWordingHtmlModalError,
    status: useWordingHtmlModalStatus,
    request: useWordingHtmlModalRequest,
  } = useWordingHtmlModal(props.match.params.idOperation);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest,
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useIsApprovedBindData,
    loading: useIsApprovedBindLoading,
    error: useIsApprovedBindError,
    status: useIsApprovedBindStatus,
    request: useIsApprovedBindRequest,
  } = useIsApprovedBind(props.match.params.idOperation);

  const {
    data: useGetSchedulleAssumptionsData,
    loading: useGetSchedulleAssumptionsLoading,
    error: useGetSchedulleAssumptionsError,
    status: useGetSchedulleAssumptionsStatus,
    request: useGetSchedulleAssumptionsRequest,
  } = useGetSchedulleAssumptions(props.match.params.idOperation);

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useGetAuthorizationPolicyDocumentsData,
    loading: useGetAuthorizationPolicyDocumentsLoading,
    error: useGetAuthorizationPolicyDocumentsError,
    status: useGetAuthorizationPolicyDocumentsStatus,
    request: useGetAuthorizationPolicyDocumentsRequest,
  } = useGetAuthorizationPolicyDocuments(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    if (useBindMessageLoading || useWordingHtmlModalLoading || useHeaderNbiLoading || useGetDocumentsLoading || useIsApprovedBindLoading || useOperationInfoLoading ||
      useGetAuthorizationPolicyDocumentsLoading || useGetQuestionnairesAnswersLoading || useGetSchedulleAssumptionsLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useBindMessageLoading, useWordingHtmlModalLoading, useHeaderNbiLoading, useGetDocumentsLoading, useIsApprovedBindLoading, useOperationInfoLoading,
    useGetAuthorizationPolicyDocumentsLoading, useGetQuestionnairesAnswersLoading, useGetSchedulleAssumptionsLoading]);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleEndorsementDocuments(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        operationStatus: data.ret_value.idOperation,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
      });
      setEndorsmentType(data.ret_value.endorsmentType);
      setIsEndorsement(data.ret_value.endorsmentType != null);
      handleGetModal(data.ret_value.endorsmentType);
    })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleGetModal(endorsmentType) {
    useWordingHtmlModalRequest().then(({data: resp}) => {
      if (resp.ret_code === 200) {
        setFile(resp.ret_value.policePackReturnDocs
          .filter(document => {
            const isEndorsement = endorsmentType && endorsmentType !== 'declaration';

            if (!isEndorsement) return true;

            return isEndorsement && ![272, 399, 401, 450, 453, 397, 493].includes(document.idDomain);
          })
          .map(document => ({
            idDocument: document.idDocument,
            idDomainDescription: document.idDomainDescription,
            idReport: document.idReport,
            idOperation: document.idOperation,
            reportToken: document.reportToken,
            url: document.url,
            fileName: document.documentMetadata.fileName
          })))
      } else {
        mc.error(resp.ret_msg_details);
      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleGetModal.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    });
  };

  const handleEnable = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingAttachments(props.match.params.idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
    });
  }

  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleApproval() {
    fitinsur.setAuthToken(authContext.token);
    let body = {
      typeUser: isClient,
      userComments: userComments,
    };

    fitinsur.requestBind(props.match.params.idOperation, body, 'approve')
      .then(response => response.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          if (endorsmentType && endorsmentType !== "declaration") {
            return history.push('/policies');
          } else {
            return history.push('/list');
          }
        } else {
          mc.error(resp.ret_msg_details);
          loading.stop();
        }
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostAproval - Error:', error);
        loading.stop();
      });

  };

  function handleReject() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    let body = {
      typeUser: isClient,
      userComments: userComments,
    };

    fitinsur.requestBind(props.match.params.idOperation, body, "reject")
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          mc.success("Approval Order To Bind Rejected");
          if (!endorsmentType) return history.push('/list');
          return history.push('/policies');
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  async function handleSchedulleAssumptions(includeSchedulle) {
    if (includeSchedulle?.idAnswerOption && includeSchedulle?.idAnswerOption == 7530) {
      useGetSchedulleAssumptionsRequest().then(({ data: response }) => {
        if (response.ret_code !== 200) {
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setScheduleAssumptionsFile({
            dsTypeDocument: "Schedule Assumptions",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        // mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
    }
  }

  const handleEndorsementDocuments = (data) => {
    const questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc
    ]

    const endorsementDocumentsQst = questionnaire.find((qst) => qst.idQuestion === 1867)
    const includeSchedulle = questionnaire.find((qst) => qst.idQuestion === 1870)

    handleSchedulleAssumptions(includeSchedulle)

    if (endorsementDocumentsQst?.answer) {
      const documents = JSON.parse(endorsementDocumentsQst.answer) || []
      setEndorsementDocuments(documents)
    }
  }

  async function handleGetFiles() {
    useGetDocumentsRequest().then(({ data: response }) => {
      if (response.ret_code !== 200) {
        mc.error(response.ret_msg_details);
        return;
      }

      if (response.ret_value.length > 0) {
        const file = response.ret_value[0];
        setWordingFile({
          dsTypeDocument: file.dsTypeDocument || "Wording",
          nameDocument: file.nameDocument,
          idTypeDocument: file.idTypeDocument,
          nameFile: file.nameFile,
          size: file.size,
          type: file.type,
          urlLink: file.urlLink,
          idDocument: file.idDocument
        });
      }
      return response.ret_value;
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
      console.error('fitPostFiles - Error:', error);
    });

    if (includeSchedulleQst?.idAnswerOption && includeSchedulleQst?.idAnswerOption === 7530) {
      fitinsur.requestAttachAssumptions(props.match.params.idOperation)
        .then(data => data.json())
        .then(response => {
          if (response.ret_code !== 200) {
            mc.error(response.ret_msg_details);
            return;
          }
          if (response.ret_value.length > 0) {
            const file = response.ret_value[0];
            setScheduleAssumptionsFile({
              dsTypeDocument: "Schedule",
              nameDocument: file.nameDocument,
              idTypeDocument: file.idTypeDocument,
              nameFile: file.nameFile,
              size: file.size,
              type: file.type,
              urlLink: file.urlLink,
              idDocument: file.idDocument
            });
          }
          return;
        }).catch((error) => {
          mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
          console.error('fitPostReject - Error:', error);
        });
    }


    loading.stop();
  }

  function handleIsApprovedBind() {
    useIsApprovedBindRequest().then(({ data: resp }) => {
      if (resp.ret_code === 200) {
        if (resp.ret_value) {
          setIsApproved(resp.ret_value.isApproved);
        }
      } else {
        mc.error(resp.ret_msg_details);
      }
    })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitIsEnabledPolicy - Error:', error);
      });
  };

  function requestBindMessage() {
    useBindMessageRequest().then(({ data: resp }) => {
      if (resp.ret_code !== 200) {
        mc.error(resp.ret_msg_details);
        history.goBack();
        return;
      }

      if (formik.current) {
        formik.current?.setFieldValue('orderToBindMessage', resp.ret_value.orderToBindMessage);
      }
    }).catch((error) => {
      mc.error("Erro executando consulta\n" + error);
      console.error('fitPostReject - Error:', error);
    });
  };

  function handleMktCompostion() {
    history.push(`/broking/market-composition/${props.match.params.idOperation}`)
  };

  function handleExecutePolicy() {
    history.push(`/broking/stamp-request-contacts/${props.match.params.idOperation}`)
  };

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({ data: response }) => {
      setIsBound(response?.isBound);
      setOperation(response)
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }

  useEffect(() => {
    requestBindMessage();
    handleSummary();
    handleEnable();
    handleGetFiles();
    handleIsApprovedBind();
    handleOperationInfo();
    getStatusPolicyDocuments();
  }, [])

  useEffect(() => {
    if (endorsmentType !== '') {
      useGetQuestionnairesAnswersRequest();
    }
  }, [endorsmentType])

  const endorsmentTypeEnum = {
    ['not-pre-agreed']: {
      title: 'Anniversary: Premium Not Pre-Agreed / Order to Bind'
    },
    ['cancellation']: {
      title: 'Endorsement - Cancellation / Order to Bind'
    }
  }

  async function getStatusPolicyDocuments() {
    useGetAuthorizationPolicyDocumentsRequest().then(({ data: response }) => {
      setIsLocked(response.ret_value.isLocked);
      setDisableExecute(!response.ret_value.executePolicy);

      if (response.ret_value.bDocument) setDocuments(response.ret_value.bDocument)

    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getStatusPolicyDocuments.name}\n` + error);
      });
  }

  const handleLock = value => {
    try {
      if (value) {
        loading.start();

        let body = {
          documents,
          idOperation: props.match.params.idOperation
        };

        fitinsur.setAuthToken(authContext.token);
        fitinsur.saveAuthorizationPolicyDocuments(body)
          .then(x => x.json())
          .then(response => {
            if (response.ret_code != 200) {
              mc.error(response.ret_msg_details);

              loading.stop();
              return;
            }

            if (formik.current) {
              formik.current?.setFieldValue('lock', value);
            }
            getStatusPolicyDocuments();
            handleIsApprovedBind();
            setDisableExecute(false);

            loading.stop();
          }).catch((error) => {
            mc.error(`There was an error while fetching your data: ${handleLock.name}\n` + error);
            loading.stop();
            history.goBack();
            return;
          })
      }
    } catch (error) {
      console.log('Error in confirm', error)
    }
  };


  const removeAttachment = item => {
    let elementToRemove, newAttachments;

    elementToRemove = documents.find((att, index) => index === item);
    newAttachments = documents.filter(attachment => attachment.documentId !== elementToRemove.documentId);
    setDocuments(newAttachments);
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      {(
        <DialogComponent icon={dialog.icon} title={dialog.title} show={dialog.visible} setDialog={setDialog}>
          {typeDialog === 'Approve' ?
            <ContentTextArea>
              <p>Deal Analysis information</p>
              <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
              <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
              <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
            </ContentTextArea>

            : typeDialog === 'Reject' ?
              <ContentTextArea>
                <p>Deal Analysis information</p>
                <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
              </ContentTextArea>
              : ''
          }
        </DialogComponent>
      )}

      <ContentCard title={endorsmentTypeEnum[endorsmentType] ?
        endorsmentTypeEnum[endorsmentType].title : (isClient || !isApproved ? 'Approval Order To Bind' : 'Order To Bind')} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{}}
          onSubmit={() => { }}
        >
          {formikProps => (
            <Form>
              <Field
                label={'Message - (External)'}
                name={'orderToBindMessage'}
                value={formikProps.values.OrderToBindMessage}
                onChange={(e) => formikProps?.setFieldValue('orderToBindMessage', e)}
                disabled
                component={TextField}
              />
              <Row style={{ flexWrap: 'nowrap', alignItems: 'flex-start' }}>
                <Col xs={12} md={5} sm={5} className="pl-2">
                  <Label style={{ width: '100%' }}>
                    By checking this box I confirmat that: an authorised broker has signed off on the policy
                    documents upon which I received the order to bind from the Insured;
                    I have made any necessary updates to the Connexion policy pack and checked to ensure
                    that there are no discrepancies between the policy documentation which the Insured has
                    instructed us to bind and the policy documentation for execution in Connexion.
                  </Label>
                </Col>
                <Col xs={12} md={7} sm={7}>
                  <Row style={{ flexWrap: 'nowrap', alignItems: 'flex-start' }}>
                    <Col xs={2} md={2} sm={2}>
                      <BorderSwitch>
                        <Field
                          disabled={isLocked || !documents.length}
                          component={Switch}
                          height={27}
                          width={55}
                          name={'lock'}
                          checked={formikProps.values.lock}
                          onChange={e => {
                            if (!documents.length) {
                              mc.error('Please, first upload the order to bind file!');
                            } else {
                              handleLock(e)
                            }
                          }
                          }
                          checkedIcon={false}
                          uncheckedIcon={false}
                          handleDiameter={20}
                          offColor={Colors.WHITE}
                          onColor={Colors.GRAY[6]}
                          offHandleColor={Colors.GRAY[6]}
                          onHandleColor={Colors.WHITE}
                        />
                      </BorderSwitch>
                    </Col>

                    <Col xs={12} md={8} sm={8}>
                      <DragZoneUpload
                        autoUpload
                        height="80"
                        multiple={false}
                        disabled={isLocked}
                        documentTypeRequired={false}
                        onSuccess={([result]) => {
                          if (result) {
                            setDocuments([result]);
                          }
                        }}
                      />

                      {(documents) && (
                        <Row style={{ flexWrap: 'nowrap', alignItems: 'flex-start' }}>
                          <Col md={12} sm={12}>
                            <TagsList3
                              small
                              tags={documents.filter(file => file.fileName).map(file => ({ ...file, dsTypeDocument: file?.documentType?.dsAnswerOption, urlLink: file.fileUrl }))}
                              disableType
                              hideTrash={isLocked}
                              removeTag={(index) => removeAttachment(index)}
                            />
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>

              </Row>
              <FileModal idOperation={props?.match?.params?.idOperation} documents={file} />

              <HasPermission permission={![26, 27].includes(operation?.idDomain) || endorsmentType === 'market-changes'}>
                <EndorsementTagList
                  tags={endorsementDocuments}
                  showRemoveIcon={false}
                  attachments={wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile ? [wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile) : []}
                />

                {wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile && (!endorsmentType || endorsmentType === '') ?
                  <>
                    <Label>Policy Pack Documents</Label>
                    <TagsList3
                      tags={[wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
                      disableType
                      hideTrash={props.location?.state?.hideFooter ? true : false}
                    />
                  </>
                  : ''}
              </HasPermission>

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <HasPermission permission={!isBound}>
                    <ButtonContent>
                      {isApproved === null ?
                        <HasPermission permission={props.permissions.ORDER_TO_BIND_APPROVE_REJECT}>
                          <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                            <Button
                              third
                              style={{ marginLeft: "10px", marginTop: "5px" }}
                              name="CDR"
                              id="mktComposition"
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}
                            >
                              CDR
                            </Button>
                          </HasPermission>
                        </HasPermission>
                        : <></>
                      }

                      {isApproved === false ?
                        <>
                          <div style={{ marginLeft: "10px", marginTop: "5px" }}>
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                          <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                            <Button
                              third
                              style={{ marginLeft: "10px", marginTop: "5px" }}
                              name="CDR"
                              id="mktComposition"
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}>
                              CDR
                            </Button>
                          </HasPermission>
                        </>
                        : <></>}

                      {isApproved === true ?
                        <>
                          <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                            <Button
                              third
                              style={{ marginLeft: "10px", marginTop: "5px" }}
                              name="CDR"
                              id="mktComposition"
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}>
                              CDR
                            </Button>
                          </HasPermission>
                        </>
                        : <></>}
                      <HasPermission permission={props.permissions.EXECUTION_SEND}>
                        <Button
                          disabled={disableExecute}
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          primary
                          id="btnSubmitApproved"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleExecutePolicy() }}>
                          {isEndorsement ? 'EXECUTE ENDORSEMENT' : 'EXECUTE POLICY'}
                        </Button>
                      </HasPermission>
                    </ButtonContent>
                  </HasPermission>
                </RenderButtons>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
